import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const useShop = ({
  baseurl,
  accessToken,
  token,
  AdminId,
  setIsUnauthorised,
}) => {
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(false);
const [filteredShops, setFilteredShops] = useState([]);

  //  FETCH SHOPS
  const fetchShops = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${baseurl}/api/Shop/v1.0/getShopList`,
        { userid: "", adminId: AdminId },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (res.data?.responseCode === "00") {
        setShops(res.data.data || []);
          setFilteredShops(res.data.data || []);
      } else if (res.data?.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data?.responseMessage || "Failed to fetch shops");
      }
    } catch (err) {
      toast.error("Error fetching shops");
    } finally {
      setLoading(false);
    }
  };

  //  ADD SHOP
  const addShop = async (payload) => {
    const res = await axios.post(
      `${baseurl}/api/Shop/v1.0/onboardShop`,
      payload,
      { headers: { Authorization: `Basic ${token}` } }
    );

    if (res.data?.responseCode === "00") {
      toast.success("Shop added");
      fetchShops();
    } else if (res.data?.responseCode === "401") {
      setIsUnauthorised(true);
    } else {
      toast.error(res.data?.responseMessage || "Failed to add shop");
    }
  };

  //  DELETE SHOP
  const deleteShop = async (shopId, onSuccess) => {
    await axios.post(
      `${baseurl}/api/Shop/v1.0/deleteShopDetails`,
      { shopId, adminId: AdminId },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    toast.success("Shop deleted");
    fetchShops();
    onSuccess?.();
  };

  //  UPDATE SHOP
  const updateShop = async (payload, onSuccess) => {
    await axios.post(
      `${baseurl}/api/Shop/v1.0/updateShopDetails`,
      payload,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    toast.success("Shop updated");
    fetchShops();
    onSuccess?.();
  };

  // ASSIGN TEAM
  const assignTeamToShop = async ({ shopId, teamId, onSuccess }) => {
    await axios.post(
      `${baseurl}/api/Driver/v1.0/assignTeamToShop`,
      { shopId, teamId, adminId: AdminId },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    toast.success("Team assigned");
    fetchShops();
    onSuccess?.();
  };

  //  FETCH LAT/LONG
  const fetchLatLong = async (address) => {
    const res = await axios.post(
      `${baseurl}/api/Task/v1.0/getLatLongs`,
      { address, adminId: AdminId },
      { headers: { Authorization: `Basic ${token}` } }
    );

    const d = res.data?.data || {};
    return {
      latitude: d.latitude || d.lat,
      longitude: d.longitude || d.lng,
    };
  };

  return {
    shops,
    setShops,
    loading,
    fetchShops,
    addShop,
    updateShop,
    deleteShop,
    assignTeamToShop,
    fetchLatLong,
  };
};

export default useShop;
